import React, { FC } from 'react';

import { InverseButton } from '@crehana/ui';
import { useMe } from '@crehana/web';
import { useProductsContainer } from '@crehana/web/dist/ReactContexts/Products';

import { useTranslation } from '@crehana/i18n';

import type { CourseCardProps } from '../../types';

interface IFreeCourseButton {
  isDark?: boolean;
  course: Partial<Pick<CourseCardProps, 'enrollmentUrl'>>;
}

const FreeCourseButton: FC<IFreeCourseButton> = ({ isDark, course }) => {
  const { t } = useTranslation();
  const { enrollmentUrl } = course;

  const { me: user } = useMe();
  const { setBasicDataForm } = useProductsContainer();

  return (
    <InverseButton
      full
      className="mt-16 rounded-10"
      onClick={() => {
        if (enrollmentUrl) {
          if (user && user.originalId) {
            if (user.phoneNumber) {
              window.location.href = enrollmentUrl;
            } else {
              setBasicDataForm({
                isOpen: true,
                // @ts-expect-error
                phoneNumberOptions: { isRequired: true },
                redirectUrl: enrollmentUrl,
              });
            }
          } else {
            window.location.href = `/onboarding/?nextUrl=${enrollmentUrl}`;
          }
        } else {
          throw new Error('Course has no enrollment url');
        }
      }}
      label={t('SUBSCRIBE_FREE', {
        defaultValue: '¡Inscríbete gratis!',
      })}
      isDark={isDark}
    />
  );
};

export default FreeCourseButton;
